import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-faqs-page',
  templateUrl: './faqs-page.component.html',
  styleUrls: ['./faqs-page.component.css']
})
export class FaqsPageComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;

  step = 0;
  faqs = [
    {
      id: '1',
      question: 'Visado de estudiante',
      answer: 'El visado de estudios habilita a su titular a permanecer en España para la realización de cursos, estudios, práctica no laboral, voluntariado, trabajos de investigación o formación no remunerados laboralmente. La duración de dicha estancia será igual a la del curso para el que esté matriculado. En el supuesto de que la estancia por studies tenga una duración superior a seis meses, el visado se emitirá con una validez de 90 días, plazo máximo en que deberá realizar la entrada al territorio español. Se deberá solicitar personalmente la tarjeta de identidad de extranjero (TIE) en el plazo de un mes desde la entrada en España, en la Oficina de Extranjería o Comisaría de Policía de la provincia donde se haya tramitado la autorización.',
      category: '',
      panelOpenState: false
    },
    {
      id: '2',
      question: '¿Qué es un Poder Generalísimo?',
      answer: 'Un poder es un documento público, realizado y autorizado por un notario público que le permite a una persona, física o jurídica, designar a otra como su representante, de modo que pueda actuar en su nombre en determinados actos jurídicos, es decir se otorga a otra persona la facultad de representarle sin que para ello necesite su autorización, o que dicha persona esté presente ante el notario en el momento del otorgamiento. El Poder Generalísimo es el más amplio, ya que el apoderado está facultado para celebrar cualquier acto y realizar cualquier trámite o gestión en name del poderdante, así como aceptar o repudiar una herencia. El otorgamiento de un Poder Generalísimo debe hacerse constar en escritura pública e inscribirse en el Registro Nacional.',
      category: '',
      panelOpenState: false
    },
    {
      id: '3',
      question: '¿Qué es la Apostilla de la Haya y para que sirve?',
      answer: 'Tiene por objeto simplificar la legalización de documentos para verificar su autenticidad, con el fin de que tengan validez a nivel internacional. A través de la Apostilla de la Haya, un país firmante reconoce la eficacia jurídica de un documento público emitido en otro país firmante de dicho Convenio. El trámite de Apostilla consiste en colocar sobre el propio documento público, una Apostilla que certificará internacionalmente  la autenticidad de la firma de los documentos públicos expedidos en cada país miembro. El tramite se debe de realizar en el Ministerio de Relaciones Exteriores y Culto de Costa Rica (Casa Amarilla) - Avenida 7-9, Calle 11-13 San José. Generalmente dan la apostilla el mismo dia, pero puede que tarden 2-3 dias en entregarlo.',
      category: '',
      panelOpenState: false
    },
    {
      id: '4',
      question: '¿Qué es el Empadronamiento y para que sirve?',
      answer: 'Empadronarse significa registrarse como residente en el ayuntamiento de la ciudad o pueblo en el que vas a vivir de forma habitual. En otras palabras, se trata de realizar el trámite necesario para que las autoridades sepan exactamente dónde vives. Es un proceso básico que se debe seguir una vez que entres al país como extranjero. ¿Y Por qué es importante? Porqué muchos procedimientos legales y de inmigración requerirán que se aporte el padrón ',
      category: '',
      panelOpenState: false
    },
    {
      id: '5',
      question: '¿Qué hacer en caso de pérdida del pasaporte?',
      answer: 'El Consulado de Costa Rica en Madrid tramita la solicitud de pasaportes digitales; y la Dirección General de Migración en Costa Rica se encarga de su impresión y su envío a España. Se deben presentar los siguientes documentos para tramitar el pasaporte digital:Original de la Cédula de Costa Rica vigente, que NO esté vencida. **Sin cédula original vigente, NO se puede hacer el pasaporte. Pasaporte original actual. El día de la cita, debe traer el pasaporte actual. **Si es solicitud de pasaporte por pérdida o robo debe presentar la DENUNCIA FORMAL ante la Policía del país donde se encuentre. Formulario de solicitud de pasaporte debidamente lleno y firmado, disponible en la página web',
      category: '',
      panelOpenState: false
    }
  ];;

  constructor() {
    // Logic to display + and - icons on clicking panels
    for(let faq of this.faqs){
      faq.panelOpenState = false;
    }
   }

  ngOnInit(): void {
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

}
